import React, { useState } from "react";
import "./ToDoAddOrUpdatePopup.css";

interface Props {
  handleClose: any;
  handleConfirmation: any;
  item?: any;
}

const CATEGORIES = ["Dům", "Garáž", "Osobní", "Crit", "Auto"];

const toDateInputValue = (value: any) => {
  if (!value) return "";
  const date = new Date(value);
  if (isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const ToDoAddOrUpdatePopup = (props: Props) => {
  const isEdit = !!(props.item && props.item.todoId);

  const [formData, setFormData] = useState({
    todoId: props.item?.todoId ?? 0,
    name: props.item?.name ?? "",
    description: props.item?.description ?? "",
    category: props.item?.category ?? "Dům",
    isRepeatable: props.item?.isRepeatable ?? false,
    frequencyInDays: props.item?.frequencyInDays ?? 7,
    dueDate: toDateInputValue(props.item?.dueDate ?? new Date()),
  });

  return (
    <div className="todoPopupRoot">
      <div className="todoOverlay" onClick={props.handleClose}></div>

      <div className="todoModal">
        <div className="todoModal__header">
          <div className="todoModal__title">
            <i className="fas fa-tasks"></i>
            {isEdit ? "Úprava úkolu" : "Přidání nového úkolu"}
          </div>
          <button
            className="todoModal__close"
            onClick={props.handleClose}
            type="button"
            aria-label="Zavřít"
          >
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="todoModal__body">
          <div className="todoField">
            <label htmlFor="name">Název</label>
            <input
              type="text"
              id="name"
              value={formData.name}
              onChange={(event) => {
                setFormData({ ...formData, name: event.target.value });
              }}
            />
          </div>

          <div className="todoField">
            <label htmlFor="description">Popis</label>
            <textarea
              id="description"
              value={formData.description}
              rows={3}
              onChange={(event) => {
                setFormData({ ...formData, description: event.target.value });
              }}
            />
          </div>

          <div className="todoField">
            <label htmlFor="category">Kategorie</label>
            <select
              id="category"
              value={formData.category}
              onChange={(event) => {
                setFormData({ ...formData, category: event.target.value });
              }}
            >
              {CATEGORIES.map((category) => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </select>
          </div>

          <div className="todoField">
            <label htmlFor="dueDate">Termín</label>
            <input
              type="date"
              id="dueDate"
              value={formData.dueDate}
              onChange={(event) => {
                setFormData({ ...formData, dueDate: event.target.value });
              }}
            />
          </div>

          {/* Repeatable task */}
          <div className="todoRepeatable">
            <label className="todoSwitch">
              <input
                type="checkbox"
                checked={formData.isRepeatable}
                onChange={(event) => {
                  setFormData({
                    ...formData,
                    isRepeatable: event.target.checked,
                  });
                }}
              />
              <span className="todoSwitch__slider"></span>
              <span className="todoSwitch__label">
                <i className="fas fa-sync-alt"></i> Opakující se úkol
              </span>
            </label>

            {formData.isRepeatable && (
              <div className="todoRepeatable__fields">
                <div className="todoField">
                  <label htmlFor="frequencyInDays">Opakování (dny)</label>
                  <input
                    type="number"
                    id="frequencyInDays"
                    min={1}
                    value={formData.frequencyInDays}
                    onChange={(event) => {
                      setFormData({
                        ...formData,
                        frequencyInDays: event.target.valueAsNumber || 0,
                      });
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="todoModal__footer">
          <button
            type="button"
            className="todoBtn todoBtn--ghost"
            onClick={props.handleClose}
          >
            Storno
          </button>
          <button
            type="button"
            className="todoBtn todoBtn--primary"
            onClick={() => {
              props.handleConfirmation(formData);
            }}
          >
            <i className="fas fa-check"></i>
            {isEdit ? "Uložit" : "Přidat"}
          </button>
        </div>
      </div>
    </div>
  );
};
